import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminRestorationPreviews from "@/pages/admin/AdminRestorationPreviews";

export const Route = createFileRoute("/admin/restoration-previews")({
  head: () => pageHead("Admin \u2014 Restoration Previews \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminRestorationPreviews,
});
